module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//build.png?v=ca40fe82";